export class CdFdProcessHelper {

    static CreateAddAgreement = "4e2b2bc5-9ee3-4769-be05-87f08533238e";
    static Sign = "80df932d-4774-42ce-a86c-d3b1d269fd38";
    static ForApproval = "BF7958CC-3013-489F-A3B9-FCC875D1E069";
    static PkSendForSigning = "2c747704-46e7-48b8-923a-34b32f3f57ea";
    static Approve = "8CF5CF41-8347-05B4-B3B2-519E8E621225";
    static ToArchive = "E95DE17A-3B74-41D5-A322-D47BC39A053D";
    static SendForResubscription = "F934F6D2-4BC3-49A5-B1A0-5F3367EF43AD";
    static PkSendForResigning = "ae5281cc-41e6-4862-8071-e3e23573ddfd";
    static SignWithEDS = "42f28e57-a763-4358-9f56-42c16308b333";
    static PkSignPaper = "dddf382b-c2b2-4746-9b27-e5412eb9338b";
    static PkSignDocument = "ddb96cfc-64bd-4797-a893-573e02e153c7";
    static PkAgree = "9cfe6de4-ad82-4c72-81c9-0dad4b67d167";
    static PkDisagree = "95772dc5-87c2-4f08-b6a9-270e203eed94";
    static PkCancelRevocation = "3ce17c57-f97e-4ac0-a534-5dc690ad42b5";
    static PkAssingNumber = "70c0260f-c8de-415b-ab53-7b44aa83e0cb";
    static PkSendByRussianPost = "e2dafa3e-a8e2-46c1-a4df-17e32e56456a";
    static PkSent = "6d62e3ba-8413-4914-9571-1079f131280a";
    static PkEnvelopePrepared = "afbd902b-c36d-4c05-a920-961ab5ab26d0";
    static Complete = "5b108223-92db-49b9-8085-336758ccabaa";
    static Confirm = '87573849-9E44-493E-830F-65CFDFAD65FE'
    static Cancel = "2582b66f-375a-0d59-ae86-a149309c5785";
    static PkDone = "dbe5f266-9e8a-4d71-9753-4837cb9ae6a5";
    static PkNotDone = "abb6c50c-115c-492e-9847-a69949304f07";
    static PkDelivered = "86638973-9d2e-4ead-b076-239c9eb37933";
    static PkNotDelivered = "1559620d-cb38-40c8-9a7f-494dd90adc3e";
    static PkNotSent = "7005720b-b420-453f-86e3-157713043d7a";
    static CreateAgreementEDO = "c58df2a0-073c-4eee-8967-e26c5e3aab95";
    static NewApprovalCycle = "c0b704b3-3ac5-4a0d-bcb6-1210e9cdb0b3";
    static PkReturnToSigner = "371a51c8-4b25-42e2-b822-501bed5a3665";
    static PkResendForApproval = "cd7bf972-f191-44fa-9e80-d48d3a6ebcd8";
    static PkFillOut = "57fbb711-30df-4cee-8684-ac419fe8aca5";
  }